import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Breadcrumb, Alert } from "react-bootstrap";
import Slider from "react-slick";
import RatingIcon from "../../../assets/icons/star.png";
import { ReactComponent as IconOffer } from "../../../assets/icons/icon-offer.svg";
import { ReactComponent as IconShare } from "../../../assets/icons/icon-share.svg";
import { ReactComponent as IconWishlist } from "../../../assets/icons/black-wishlist-icon.svg";
import SliderImage from "react-zoom-slider";
import { useDispatch, useSelector } from "react-redux";
import { data } from "../../../Data/data";
import Size from "../../ProductListing/components/Size/Size";
import ColorBox from "../../ProductListing/components/ColorsBox/ColorBox";
import Button from "../../../components/popup/Forms/Button/Button";
import {
  PROMO_CODE,
  VIEW_REVIEW,
  PRODUCT_DATA,
  VIEW_PRODUCT,
  PRODUCT_WISHLIST_ADD,
  PRODUCT_WISHLIST_REMOVE,
  ADD_TO_CART,
} from "../../../Redux/SagaAction/actions";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Signin, checkout, mycart } from "../../../config/RoutingConsts";
import {
  addRemoveWishList,
  addToCartSuccess,
  addToWishlist,
  getOderSummarySuccess,
} from "../../../Redux/Slices/ProductSlice";
import { ReactComponent as WishListImage } from "../../../assets/images/image.svg";
import { ReactComponent as MyWishlistIcon } from "../../../assets/icons/black-wishlist-icon.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ProductCardCM from "../../../components/ProductCardCM/ProductCardCM";
import { userpopupShowingCount } from "../../../Redux/Slices/AuthSlice";
import { decrypt } from "../../../Crypto/function";
import {
  errorToast,
  successToast,
} from "../../../components/ToastifyCM/Toastify";
import ImageLoder from "../../../components/ImageLoder";

const ProductZoom = ({
  viewProduct,
  setViewId,
  viewId,
  viewSizeId,
  setViewSizeId,
  CodeCopied,
  existCode,
  AddedToWishlist,
  color,
  size,
  setColor,
  setSize,
}) => {
  const navigate = useNavigate();
  const toastId = useRef(null);
  const dispatch = useDispatch();
  const [selectshopFilter, setSelectshopFilter] = useState([]);
  const [ischecked, setIschecked] = useState([]);
  const [copiedCode, setCopiedCode] = useState("");
  const { productId } = useParams();
  const { authToken, isLogin } = useSelector((e) => e.AuthSlice);
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };
  const [count,setCount] = useState(1)

  const handleCopy = (code) => {
    setCopiedCode(code);
    if (copiedCode) {
      setCopiedCode("");
      existCode();
    } else {
      CodeCopied(code);
    }
  };

  const formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  const handleCart = (data, apk) => {
    let cart = null;
    cart = {
      id: data?.id,
      productName: data?.productName,
      description: data?.description,
      color: data?.addVariant?.[0]?.color,
      colorId: data?.addVariant?.[0]?.colorId,
      productImages: data?.addVariant?.[0]?.productImages,
      productSku: data?.addVariant?.[0]?.productSku,
      // variantList:s,
      size: data?.addVariant?.[0]?.variantList?.[0]?.size,
      sellingPrice: data?.addVariant?.[0]?.variantList?.[0]?.sellingPrice,
      qty: 1,
      sizeId: data?.addVariant?.[0]?.variantList?.[0]?.sizeId,
      availableQty: data?.addVariant?.[0]?.variantList?.[0]?.availableQty,
      PLength: data?.addVariant?.[0]?.variantList?.[0]?.PLength,
      mrp: data?.addVariant?.[0]?.variantList?.[0]?.mrp,
      _id: data?.addVariant?.[0]?.variantList?.[0]?._id,
      orderSummary: true,
    };
    dispatch(getOderSummarySuccess(cart));
    return apk ? navigate(checkout) : navigate(mycart);
  };
  const maxLength = 30;
  const shortenedText =
    viewProduct?.productName?.length > maxLength
      ? viewProduct?.productName?.substring(0, maxLength - 3) + "..."
      : viewProduct?.productName;
  return (
    <Container>
      <Row>
        <Col lg="12">
          <Breadcrumb className="mb-30">
            <Breadcrumb.Item href="/swanee">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>{shortenedText}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>

        <Col xl="6" lg="12">
          <div className="product-image">
            {viewProduct?.addVariant?.map((viewList, index) => {
              return (
                <>
                  {viewId === viewList?._id && (
                    <div className="hover-icon">
                      <div className="gradiant-bg">
                        {viewList?.variantList?.map((wish) => {
                          return (
                            wish?.sizeId === viewSizeId &&
                            (wish?.isWishList ? (
                              <WishListImage
                                onClick={(e) => {
                                  if (authToken && isLogin) {
                                    dispatch(
                                      addRemoveWishList({
                                        isWishList: false,
                                        _id: viewList?._id,
                                        sizeId: wish?.sizeId,
                                      })
                                    );
                                    dispatch({
                                      type: PRODUCT_WISHLIST_REMOVE,
                                      payload: {
                                        catalogId: decrypt(productId),
                                        variantId: viewList?._id,
                                        sizeId: viewSizeId,
                                      },
                                      callback: (e) => {
                                        toast.dismiss(toastId.current);
                                        toastId.current = successToast(e);
                                      },
                                    });
                                  } else {
                                    dispatch(userpopupShowingCount(1));
                                  }
                                  // dispatch({type:PRODUCT_WISHLIST_ ,payload:{catalogId:data?.id}})
                                }}
                              />
                            ) : (
                              <MyWishlistIcon
                                onClick={() => {
                                  if (authToken && isLogin) {
                                    dispatch(
                                      addRemoveWishList({
                                        isWishList: true,
                                        _id: viewList?._id,
                                        sizeId: wish?.sizeId,
                                      })
                                    );
                                    dispatch({
                                      type: PRODUCT_WISHLIST_ADD,
                                      payload: {
                                        catalogId: decrypt(productId),
                                        variantId: viewList?._id,
                                        sellingPrice:
                                          viewList?.variantList?.[0]
                                            ?.sellingPrice,
                                        sizeId: viewSizeId,
                                      },
                                      callback: (e) => {
                                        toast.dismiss(toastId.current);
                                        toastId.current = successToast(e);
                                      },
                                    });
                                  } else {
                                    dispatch(userpopupShowingCount(1));
                                  }
                                }}
                              />
                            ))
                          );
                        })}
                        {/* {viewList?.isWishList ? (
                          <WishListImage
                            onClick={(e) => {
                              if (authToken && isLogin) {
                                dispatch(
                                  addRemoveWishList({
                                    isWishList: false,
                                    _id: viewList?._id,
                                  })
                                );
                                dispatch({
                                  type: PRODUCT_WISHLIST_REMOVE,
                                  payload: {
                                    catalogId: decrypt(productId),
                                    variantId: viewList?._id,
                                    sizeId:viewSizeId
                                  },
                                  callback:(e)=> {
                                   toast.dismiss(toastId.current)
                                   toastId.current = successToast(e)
                                  }
                                });
                              } else {
                                dispatch(userpopupShowingCount(1));
                              }
                              // dispatch({type:PRODUCT_WISHLIST_ ,payload:{catalogId:data?.id}})
                            }}
                          />
                        ) : (
                          <MyWishlistIcon
                            onClick={() => {
                              if (authToken && isLogin) {
                                dispatch(
                                  addRemoveWishList({
                                    isWishList: true,
                                    _id: viewList?._id,
                                  })
                                );
                                dispatch({
                                  type: PRODUCT_WISHLIST_ADD,
                                  payload: {
                                    catalogId: decrypt(productId),
                                    variantId: viewList?._id,
                                    sellingPrice:
                                      viewList?.variantList?.[0]?.sellingPrice,
                                      sizeId : viewSizeId
                                  },
                                  callback:(e)=> {
                                    toast.dismiss(toastId.current)
                                     toastId.current = successToast(e)
                                  }
                                });
                              } else {
                                dispatch(userpopupShowingCount(1));
                              }
                            }}
                          />
                        )} */}
                      </div>
                    </div>
                  )}
                  {viewId === viewList?._id && (
                    <SliderImage data={viewList?.productImages} />
                    // <SliderImage data={viewList?.productImages?.map((imageData, index) => {
                    //   console.log("Image Data:", imageData);
                    //   console.log("Image URL:", imageData?.image);
                    //   if (imageData?.image) {
                    //     return <img src={imageData?.image} alt={`Image ${index}`} />;
                    //   }
                    //   return null;
                    // })} />
                  )}
                  <div className="custom-slider product-thum-slider desktop-none">
                    {viewId === viewList?._id && (
                      <Slider {...settings}>
                        {viewList?.productImages?.map((list, index) => {
                          return (
                            <ProductCardCM
                              data={list}
                              toastId={toastId}
                              viewList={viewList}
                              zoomImages
                              viewSizeId={viewSizeId}
                            />
                          );
                        })}
                      </Slider>
                    )}
                  </div>
                </>
              );
            })}
          </div>
        </Col>
        <Col xl="6" lg="12">
          <div className="product-detail">
            <div className="product-heading">
              <div className="title">{viewProduct?.productName}</div>
              <span className="subtitle">{shortenedText}</span>
            </div>
            <div className="rating-details">
              <span>
                {viewProduct?.rating}4
                <img src={RatingIcon} alt="star" />
              </span>
              <span>{viewProduct?.subrating} Ratings</span>
            </div>
            <div className="share">
              <IconShare /> Share
            </div>

            {viewProduct?.addVariant?.map(
              (viewPriceData, index) =>
                viewId === viewPriceData?._id &&
                viewPriceData?.variantList?.map((viewPrice, i) => {
                  return (
                    viewSizeId === viewPrice?.sizeId && (
                      <>
                        <div className="price" key={i}>
                          <span className="original-price">
                            ₹ {formatNumber(viewPrice?.sellingPrice)}
                          </span>
                          {viewPrice?.mrp != viewPrice?.sellingPrice && (
                            <span className="seller-price">
                              ₹ {formatNumber(viewPrice?.mrp)}
                            </span>
                          )}
                          {viewProduct?.offer && (
                            <span className="text-red">
                              {viewProduct?.offer}% OFF
                            </span>
                          )}
                        </div>
                        <span>Inclusive of all taxes</span>
                        {viewPrice?.availableQty > 0 &&
                          viewPrice?.availableQty < 20 && (
                            <div
                              className={
                                viewPrice?.availableQty > 5
                                  ? "stock"
                                  : "few-stock"
                              }
                            >
                              <p>
                                {/* {viewPrice?.availableQty === 0 && "Out of Stock"} */}
                                {viewPrice?.availableQty === 1 &&
                                  `Only ${viewPrice?.availableQty} Item Left`}
                                {viewPrice?.availableQty <= 5 &&
                                  viewPrice?.availableQty !== 0 &&
                                  viewPrice?.availableQty !== 1 &&
                                  `Only ${viewPrice?.availableQty} Items Left`}
                                {viewPrice?.availableQty > 5 &&
                                  `${viewPrice?.availableQty} Items Left`}
                              </p>
                            </div>
                          )}
                        <div className="product-filter">
                          {viewProduct?.addVariant && <h6>Color</h6>}
                          <ColorBox
                            setViewSizeId={setViewSizeId}
                            viewProduct={viewProduct?.addVariant}
                            setViewId={setViewId}
                            viewId={viewId}
                            selectshopFilter={selectshopFilter}
                            display={viewProduct?.addVariant?.[0]?.color}
                            setSelectshopFilter={setSelectshopFilter}
                            ischecked={ischecked}
                            setIschecked={setIschecked}
                            fixColor="true"
                            color={color}
                            setColor={setColor}
                            size={size}
                            setSize={setSize}
                          />
                          {viewProduct?.addVariant && <h6>Select Your Size</h6>}
                          <Size
                            viewId={viewId}
                            viewSizeId={viewSizeId}
                            setViewSizeId={setViewSizeId}
                            viewProduct={viewProduct?.addVariant}
                            selectshopFilter={selectshopFilter}
                            setSelectshopFilter={setSelectshopFilter}
                            ischecked={ischecked}
                            setIschecked={setIschecked}
                            fixSize="true"
                            setSize={setSize}
                            size={size}
                          />
                        </div>
                        <div
                          className={`${
                            viewPrice?.availableQty === 0
                              ? "button-wrap"
                              : "button-group"
                          }`}
                        >
                          <div className="quantity-group">
                            <button
                              // onClick={() => {
                              //   if (data?.addCount > 1) {
                              //     decrementCount({
                              //       id: data?.cartId,
                              //       dCount: data?.addCount,
                              //     });
                              //   }
                              // }}
                              onClick={()=> {
                                if(count > 1){
                                  setCount(
                                    count-1
                                  )
                                }
                              }}
                              className="count min"
                              type="button"
                            ></button>

                            <input
                              type="text"
                              value={
                                // data?.availableQty === 0
                                //   ? data?.availableQty
                                //   : data?.addCount
                                count
                              }
                            />
                            <button
                              // onClick={() => {
                              //   if (data?.addCount !== data?.availableQty) {
                              //     incrementCount({
                              //       id: data?.cartId,
                              //       count:
                              //         data?.availableQty === 0
                              //           ? data?.availableQty
                              //           : data?.addCount,
                              //     });
                              //   }
                              // }}
                              onClick={()=> {
                              
                                setCount(
                                  count+1
                                )
                              }}
                              className="count max"
                              type="button"
                            ></button>
                          </div>
                          <div className="price" key={i}>
                          <span className="original-price">
                            ₹ {formatNumber(count*viewPrice?.sellingPrice)}
                          </span>
                        </div>
                          {/* <Button
                            commonClass={`common-btn ${
                              viewPrice?.availableQty === 0 && "out-of-stock"
                            }`}
                            text={
                              viewPrice?.availableQty === 0
                                ? "Out of Stock"
                                : "Buy Now"
                            }
                            type="Button"
                            onClick={() => {
                              // dispatch({type : ADD_TO_CART,payload:{
                              //   catalogId: viewProduct?.id,
                              //   variantId: viewPrice?._id,
                              // },callback:()=> {
                              navigate(checkout);
                              // }})
                              // if(viewPrice?.availableQty !== 0){
                              // handleCart(viewProduct, true);
                              // }
                            }}
                          /> */}
                          {viewPrice?.availableQty !== 0 && (
                            <Button
                              commonClass={"common-btn border-btn"}
                              // text={`${
                              //   viewPrice?.isCart ? "Go To Cart" : "Add To Cart"
                              // }`}
                              text="Add To Cart"
                              type="Button"
                              onClick={() => {
                                if (!isLogin) {
                                  dispatch(userpopupShowingCount(1));
                                } else {
                                  dispatch({
                                    type: ADD_TO_CART,
                                    payload: {
                                      catalogId: viewProduct?.id,
                                      variantId: viewPriceData?._id,
                                      sizeId: viewSizeId,
                                    },
                                    callback: () => {
                                      // navigate(mycart);
                                    },
                                  });
                                }
                                // if (viewPrice?.isCart) {
                                //   navigate(mycart);
                                // } else {
                                //   dispatch({
                                //     type: ADD_TO_CART,
                                //     payload: {
                                //       catalogId: viewProduct?.id,
                                //       variantId: viewPriceData?._id,
                                //       sizeId: viewSizeId,
                                //     },
                                //     callback: () => {
                                //       navigate(mycart);
                                //     },
                                //   });
                                // }
                              }}
                            />
                          )}
                          <ToastContainer ref={toastId} />
                        </div>
                      </>
                    )
                  );
                })
            )}

            <div className="product-offer">
              <h6 className="offer-head">
                Best Offers <IconOffer />
              </h6>
              <p>
                ShopMore30k
                <span
                  className="text-red"
                  onClick={() => {
                    handleCopy("ShopMore30k");
                  }}
                >
                  {copiedCode ? copiedCode : "Copy Code"}
                </span>
              </p>
              <ul>
                <li>
                  <span>
                    Shop for 7,905 more and get flat 3,000 OFF! Use coupon code
                    ShopMore30 (T&C Applied).
                  </span>
                </li>
              </ul>

              <p>ShopMore30k</p>
              <ul>
                <li>
                  <span>
                    Shop for 7,905 more and get flat 3,000 OFF! Use coupon code
                    ShopMore30k(T&C Applied).
                  </span>
                </li>
              </ul>

              <h6>
                Best Offers <span className="text-red">Know More</span>
              </h6>
              <span>If you find the product for less we’ll match it!</span>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ProductZoom;
